import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var ProgressBar = function ProgressBar(props) {
  var className = props.className,
    dataTestId = props['data-testid'],
    indeterminate = props.indeterminate,
    _props$percentComplet = props.percentComplete,
    percentComplete = _props$percentComplet === void 0 ? 0 : _props$percentComplet;
  alertUserOfDeprecatedProps('ProgressBar', props);
  var finalClasses = classnames('C-ProgressBar', {
    '--indeterminate': indeterminate,
    '--success': parseInt(percentComplete) >= 100
  }, className);
  var styles = {
    width: percentComplete + '%'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: finalClasses,
    "data-testid": dataTestId,
    role: "progressbar",
    "aria-live": indeterminate ? 'off' : 'polite',
    "aria-valuenow": indeterminate ? 'moving progress from 0 to 100 to show loading' : percentComplete,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }, /*#__PURE__*/React.createElement("span", {
    style: styles,
    className: "C-ProgressBar__progress"
  }));
};
ProgressBar.displayName = 'ProgressBar';

export { ProgressBar as default };
